import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceList from "./pages/ServiceList";
import ServiceDetail from "./pages/ServiceDetail";
import Booking from "./pages/Booking";
import Products from "./pages/Products";
import ComingSoon from "./pages/ComingSoon";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import OurStory from "./pages/OurStory";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Cart from "./pages/Cart";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="services" element={<Services />} />
              <Route path="services/mens-studio" element={<ServiceList category="mens" title="Men's Studio" intro="Sharp, considered men's grooming. Precision cuts, skin fades, beard sculpting." />} />
              <Route path="services/womens" element={<ServiceList category="womens" title="Women's Hair" intro="Cuts, color and styling crafted for movement, dimension and shine." />} />
              <Route path="services/detail/:slug" element={<ServiceDetail />} />
              <Route path="booking" element={<Booking />} />
              <Route path="products" element={<Products />} />
              <Route path="training" element={<ComingSoon kind="academy" title="AXtreme Academy launches soon" subtitle="Be first in line for enrollment — leave your email and we'll reach out." source="academy" />} />
              <Route path="careers" element={<Careers />} />
              <Route path="contact" element={<Contact />} />
              <Route path="our-story" element={<OurStory />} />
              <Route path="auth" element={<Auth />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="cart" element={<Cart />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
